import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import HomeGoals from '../../../assets/images/home_goals.png';
import { useCountry } from '../../../contexts/CountryContext';
import useDesignUtils from '../../../hooks/useDesignUtils';
import { Box, Copy, HStack, NewPrimaryButton, VStack } from '../../SimpleUI';
import SectionLayout from '../SectionLayout';

const StepItem = styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 45px;
  max-width: 45px;
  background: #d4c6ff;
  border-radius: 50%;
  color: #845cff;
  font-size: 30px;
  font-weight: 700;
  box-shadow: 0px 0px 0px 6px white;
  z-index: 3;
`;

const List = styled.ul`
  display: grid;
  gap: 30px;
  padding: 0;
  list-style-type: none;
  position: relative;
  &::after {
    position: absolute;
    content: '';
    width: 2px;
    height: 80%;
    top: 15px;
    left: 22px;
    background: #d4c6ff;
    z-index: 2;
    border-radius: 10px;
  }
  & > li + li {
    margin-top: 10px;
  }
  & > li:last-child > div > div::after {
    content: none;
  }
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const GoalsInfo = () => {
  const { isMobile } = useDesignUtils();
  const { countryPrefix } = useCountry();
  const history = useHistory();

  const StackDirection = isMobile ? VStack : HStack;
  return (
    <SectionLayout paddingY="large" backgroundColor="white">
      <Box
        width="100%"
        maxWidth="1200px"
        paddingX="medium"
        margin="auto"
        marginY="xxxlarge"
      >
        <Copy
          fontSize="bigTitle"
          tag="h2"
          fontWeight="bold"
          color="_lightPurple"
          textAlign="center"
        >
          Te ayudamos a cumplir tus metas
        </Copy>
        <StackDirection
          justifyContent="space-around"
          alignItems={isMobile ? 'center' : 'flex-start'}
          space="medium"
          marginTop="xlarge"
        >
          <Box width={{ mobile: '100%', desktop: '60%' }} maxWidth="550px">
            <Box tag="img" src={HomeGoals} width="100%" maxWidth="600px" />
          </Box>
          <Box
            width={{ mobile: '100%', desktop: '40%' }}
            display="flex"
            alignItems="center"
            flexDirection="column"
            marginTop={{ mobile: 'none', desktop: 'large' }}
          >
            <List>
              <li>
                <HStack alignItems="center" space="medium">
                  <StepItem>1</StepItem>
                  <Copy fontSize="_itemList" color="purple">
                    Elegí tu objetivo-meta
                  </Copy>
                </HStack>
              </li>
              <li>
                <HStack alignItems="center" space="medium">
                  <StepItem>2</StepItem>
                  <Copy fontSize="_itemList" color="purple">
                    Sumá dinero de forma mensual
                  </Copy>
                </HStack>
              </li>
              <li>
                <HStack alignItems="center" space="medium">
                  <StepItem>3</StepItem>
                  <Copy fontSize="_itemList" color="purple">
                    Te ofrecemos el mejor camino para cumplir tus objetivos.
                  </Copy>
                </HStack>
              </li>
              <li>
                <HStack alignItems="center" space="medium">
                  <StepItem>4</StepItem>
                  <Copy fontSize="_itemList" color="purple">
                    Mirá cuánto más rápido alcanzás esos objetivos con tus
                    ahorros mensuales.
                  </Copy>
                </HStack>
              </li>
            </List>
            <Box
              width="100%"
              maxWidth={{ mobile: '100%', desktop: '270px' }}
              marginRight="auto"
              marginTop="large"
            >
              <NewPrimaryButton
                type="button"
                variant="purple"
                size="full"
                fontSize="bigText"
                onClick={() => history.push(`${countryPrefix}/productos#metas`)}
              >
                Simulá tu próxima meta
              </NewPrimaryButton>
            </Box>
          </Box>
        </StackDirection>
        <Box height="80px" />
      </Box>
    </SectionLayout>
  );
};

export { GoalsInfo };
